import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RichTextViewComponent } from 'shared/feature-rich-text-view';

import { CommentableTextDirective } from '@treetop/shared/comments';
import { TextWidget } from '@treetop/shared/model';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-text-widget',
  templateUrl: './text-widget.component.html',
  styleUrls: ['./text-widget.component.scss'],
  imports: [CommentableTextDirective, RichTextViewComponent],
})
export class TextWidgetComponent {
  public widget = input.required<TextWidget>();

  protected text = computed(() => {
    const local = this.widget().localChanges?.text;
    const original = this.widget().text;

    return local === undefined || local === null ? (original ?? '') : local;
  });

  protected readonly console = console;
}
